<template>
    <!-- <div id="login">
        <h3 class="text-center text-white pt-5">Login form</h3>
        <div class="container">
            <div id="login-row" class="row d-flex justify-content-center align-items-center">
                <div id="login-column" class="col-md-6">
                    <div id="login-box" class="col-md-12">
                        <form id="login-form" class="form" @submit.prevent="login()">
                            <h3 class="text-center text-info">Baidyabati Municipality Login</h3>
                            <div class="form-group">
                                <label for="username" class="text-info">Email:</label><br>
                                <input type="text" name="username" id="username" v-model="loginForm.email" class="form-control form-control-sm">
                            </div>
                            <div class="form-group mb-2">
                                <label for="password" class="text-info">Password:</label><br>
                                <input type="password" name="password" id="password" v-model="loginForm.password" class="form-control form-control-sm">
                            </div>
                            <div class="mb-2">
                                <router-link to="#"  style="text-decoration: none;">forgot password</router-link>
                            </div>
                            <div>
                                <button class="btn btn-primary text-white" style="background-color: #60b3f2; border-radius: 0px;" type="submit">Sign In</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <main class="form-signin">
        <form @submit.prevent="login()">
            <img class="mb-4" :src="this.base_url + '/assets/img/govt_logo.jpeg'" alt="" width="72" height="57">
            <h1 class="h3 mb-3 fw-normal">Waste Generator Data Collection Management System (WGDCMS) Baidyabati Municipality</h1>

            <div class="form-floating">
                <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com" v-model="loginForm.email">
                <label for="floatingInput">Email address</label>
            </div>

            <div class="form-floating">
                <input type="password" class="form-control" id="floatingPassword" placeholder="Password" v-model="loginForm.password">
                <label for="floatingPassword">Password</label>
            </div>

            <div class="checkbox mb-3">
                <label>
                    <input type="checkbox" value="remember-me"> Remember me
                </label>
            </div>

            <button class="w-100 btn btn-lg btn-primary" type="submit">Sign in</button>
            <p class="mt-5 mb-3 text-muted">&copy; 2025–2026</p>
        </form>
    </main>
  </template>
  
<script>
    import axios from 'axios';

    export default {

        data() {
            return {
                loginForm :{
                    email:'',
                    password:''
                }
            }
        },
        methods:{

            login()
            {
                axios.post('/api/login/',this.loginForm)
                    .catch((error) => {
                    if(error.response.status == 401) {
                        localStorage.removeItem('guard');
                        localStorage.removeItem('token');
                        this.$swal({
                            icon: 'error',
                            title: 'Session Expired please login!',
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 4000
                        });
                        this.$router.push('/login');
                    } 
                }).then((response) =>{
                    if(response.data['success'] == true)
                    {
                        this.$swal({
                            icon: 'success',
                            title: ' '+response.data['message'],
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 4000
                        });
                        this.$router.push('/');
                        localStorage.setItem('guard'    ,response.data['guard']);
                        localStorage.setItem('token'    ,response.data['token']);
                        localStorage.setItem('name'     ,response.data['name']);
                        setTimeout(function(){location.reload()}, 10);
                    }
                    if(response.data['success'] == false)
                    {
                        this.$swal({
                            icon: 'error',
                            title: ' '+response.data['error'],
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 4000
                        });
                    }
                });
            },
            // if the user loged in prevention for not go to log in page again
            checkLoggedIn()
            {
                let token = localStorage.getItem('token');
                if(token){
                    this.$router.push('/');
                }else{
                    this.$router.push('/login');
                }
            }

        },
        created()
        {
            this.base_url = window.location.origin;
            this.checkLoggedIn();
        }
    }
</script>
  <style scoped>
 #login .container #login-row #login-column #login-box {
  margin-top: 120px;
  max-width: 600px;
  height: 320px;
  border: 1px solid #9C9C9C;
  background-color: #EAEAEA;
}
#login .container #login-row #login-column #login-box #login-form {
  padding: 20px;
}
#login .container #login-row #login-column #login-box #login-form #register-link {
  margin-top: -85px;
}

  </style>
  